import React, { Component } from 'react';

import '../css/marcas.css'

import marca1 from '../img/logo-1.jpg'
import marca2 from '../img/logo-2.jpg'
import marca3 from '../img/logo-3.jpg'
import marca4 from '../img/logo-4.jpg'
import marca5 from '../img/logo-5.jpg'
import marca6 from '../img/logo-6.jpg'
import marca7 from '../img/logo-7.jpg'
import marca8 from '../img/logo-8.jpg'
import marca9 from '../img/logo-9.jpg'
import marca10 from '../img/logo-10.jpg'
import marca11 from '../img/logo-11.jpg'
import marca12 from '../img/logo-12.jpg'
import marca13 from '../img/logo-13.jpg'
import marca14 from '../img/logo-14.jpg'
import marca15 from '../img/logo-15.jpg'
import marca16 from '../img/logo-16.jpg'
import marca17 from '../img/logo-17.jpg'
import marca18 from '../img/logo-18.jpg'
import marca19 from '../img/logo-19.jpg'
import marca20 from '../img/logo-20.jpg'
import marca21 from '../img/logo-21.jpg'
import marca22 from '../img/logo-22.jpg'
import marca23 from '../img/logo-23.jpg'
import marca24 from '../img/logo-24.jpg'
import marca25 from '../img/logo-25.jpg'
import marca26 from '../img/logo-26.jpg'

class Marcas extends Component {
  render() {
    return (
      <div className="container mt-4">
        <div className="textomarcas row align-items-center no-gutters">
          <div className="col">
            Marcas que comercializamos
          </div>
        </div>

        <div className="marcastodo row justify-content-center no-gutters p-4">

          <div className="marca col-auto">
            <div><img className="marcas" src={marca1} alt=""/></div>
          </div>
          <div className="marca col-auto">
            <div><img className="marcas" src={marca2} alt=""/></div>
          </div>
          <div className="marca col-auto">
            <div><img className="marcas" src={marca3} alt=""/></div>
          </div>
          <div className="marca col-auto">
            <div><img className="marcas" src={marca4} alt=""/></div>
          </div>
          <div className="marca col-auto">
            <div><img className="marcas" src={marca5} alt=""/></div>
          </div>

          <div class="w-100"></div>

          <div className="marca col-auto">
            <div><img className="marcas" src={marca6} alt=""/></div>
          </div>
          <div className="marca col-auto">
            <div><img className="marcas" src={marca7} alt=""/></div>
          </div>
          <div className="marca col-auto">
            <div><img className="marcas" src={marca8} alt=""/></div>
          </div>
          <div className="marca col-auto">
            <div><img className="marcas" src={marca9} alt=""/></div>
          </div>
          <div className="marca col-auto">
            <div><img className="marcas" src={marca10} alt=""/></div>
          </div>

          <div class="w-100"></div>

          <div className="marca col-auto">
            <div><img className="marcas" src={marca11} alt=""/></div>
          </div>
          <div className="marca col-auto">
            <div><img className="marcas" src={marca13} alt=""/></div>
          </div>
          <div className="marca col-auto">
            <div><img className="marcas" src={marca14} alt=""/></div>
          </div>
          <div className="marca col-auto">
            <div><img className="marcas" src={marca15} alt=""/></div>
          </div>
          <div className="marca col-auto">
            <div><img className="marcas" src={marca12} alt=""/></div>
          </div>

          <div class="w-100"></div>

          <div className="marca col-auto">
            <div><img className="marcas" src={marca16} alt=""/></div>
          </div>
          <div className="marca col-auto">
            <div><img className="marcas" src={marca17} alt=""/></div>
          </div>
          <div className="marca col-auto">
            <div><img className="marcas" src={marca18} alt=""/></div>
          </div>
          <div className="marca col-auto">
            <div><img className="marcas" src={marca19} alt=""/></div>
          </div>

          <div class="w-100"></div>

          <div className="marca col-auto">
            <div><img className="marcas" src={marca20} alt=""/></div>
          </div>
          <div className="marca col-auto">
            <div><img className="marcas" src={marca21} alt=""/></div>
          </div>
          <div className="marca col-auto">
            <div><img className="marcas" src={marca22} alt=""/></div>
          </div>
          <div className="marca col-auto">
            <div><img className="marcas" src={marca23} alt=""/></div>
          </div>
          <div className="marca col-auto">
            <div><img className="marcas" src={marca24} alt=""/></div>
          </div>

          <div class="w-100"></div>

          <div className="marca col-auto">
            <div><img className="marcas" src={marca25} alt=""/></div>
          </div>
          <div className="marca col-auto">
            <div><img className="marcas" src={marca26} alt=""/></div>
          </div>

        </div>
      </div>
    )
  }
}

export default Marcas;
